import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from './common/ConfirmationModal';

import './common/modal.scss';

/**
 * Component for rendering and managing recorder control buttons based on recording status.
 * Handles actions such as starting, stopping, and re-recording recordings, toggling instruction overlay, and uploading videos.
 */
const RecorderButtons = ({
    status,
    trans,
    recorderOptions,
    isWebcamOpen,
    toggleInstructionOverlay = () => { },
    startRecording = () => { },
    stopRecording = () => { },
    startOverRecording = () => { },
    reRecordRecording = () => { },
    handleUploadClick = () => { },
    startScreenRecording = () => { },
    stopScreenRecording = () => { },
}) => {
    const [isOpenConfirmation, setIsOpenConfirmation] = useState(false);
    const showScriptButton = recorderOptions?.showScriptButton ?? false;
    const showStartOverButton = recorderOptions?.showStartOverButton ?? false;
    const showReRecordButton = recorderOptions?.showReRecordButton ?? false;
    const showUploadButton = recorderOptions?.showUploadButton ?? false;
    return (
        <>
            {/* Conditional rendering based on recording status  */}
            {
                ['beginRecording', 'beginReview'].includes(status) && (
                    <div className="tv-recorder__buttons">
                        {
                            showScriptButton && isWebcamOpen && <button type="button" className="btn btn--primary-alt margin-r-auto" onClick={toggleInstructionOverlay}>Toggle Script</button>
                        }
                        {
                            showUploadButton && <button className="btn btn--cancel" type="button" onClick={handleUploadClick}><i className="fas fa-upload"></i>Upload a Video</button>
                        }
                        {
                            status === 'beginRecording' && <button type="button" className="btn btn--primary margin-l-auto" onClick={startRecording}>{trans['rec-start']}</button>
                        }
                        {
                            showReRecordButton && status === 'beginReview' && <button className="btn btn--primary-alt" onClick={() => setIsOpenConfirmation(true)}>Re-record</button>
                        }
                        {/* Render confirmation modal for re-recording */}
                        <ConfirmationModal
                            isOpen={isOpenConfirmation}
                            title={'Rerecord this video?'}
                            cancelButtonTitle={'Go Back'}
                            proceedButtonTitle={'Rerecord Video'}
                            onCancel={() => setIsOpenConfirmation(false)}
                            onProceed={() => {
                                setIsOpenConfirmation(false);
                                reRecordRecording();
                            }}
                        >
                            <p style={{
                                fontSize: 16,
                                overflowWrap: 'break-word',
                                marginBottom: 25,
                                marginTop: 25,
                                textAlign: 'center',
                            }}>
                                Do you want to rerecord this video? Your current recorded video will not be saved.
                            </p>
                        </ConfirmationModal>
                    </div>
                )
            }
            {/* Render buttons during recording */}
            {
                status === 'recording' && (
                    <div className="tv-recorder__buttons">
                        {
                            showScriptButton && <button type="button" className="btn btn--secondary margin-r-auto" onClick={toggleInstructionOverlay}>Toggle Script</button>
                        }
                        {
                            showStartOverButton && <button type="button" className="btn btn--primary" onClick={startOverRecording}>{trans['start-over']}</button>
                        }
                        <button type="button" className="btn btn--primary margin-l-auto" onClick={stopRecording}>{trans['rec-stop']}</button>
                    </div>
                )
            }
        </>
    );
};

RecorderButtons.propTypes = {
    status: PropTypes.string,
    trans: PropTypes.object,
    isWebcamOpen: PropTypes.bool,
    recorderOptions: PropTypes.object,
    toggleInstructionOverlay: PropTypes.func,
    startRecording: PropTypes.func,
    stopRecording: PropTypes.func,
    startOverRecording: PropTypes.func,
    reRecordRecording: PropTypes.func,
    handleConfirmationClose: PropTypes.func,
    handleUploadClick: PropTypes.func,
    startScreenRecording: PropTypes.func,
    stopScreenRecording: PropTypes.func,
};

export default RecorderButtons;
